module.exports = __webpack_public_path__ + "static/img/msy-xcx.13d77bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msy-xcx.jpg
// module id = 7Yaa
// module chunks = 110